import { CustomFilterComponent } from '../grid-filters/custom-grid-filter';
import {
  EntitySummaryRendererComponent,
  FlexButtonGroupRendererComponent,
} from './cellRender';

import { CheckboxCellComponent } from './cellRender/checkbox-cell/checkbox-cell.component';
import { CheckboxHeaderCellComponent } from './cellRender/checkbox-header-cell/checkbox-header-cell.component';
import { XVICustomSelectRendererComponent } from './cellRender/custom-select-renderer/custom-select-renderer.component';
import { XEAPopoverComponent } from './cellRender/popover-base/popover-base.component';
import {
  XEAPopoverHeaderCellRendererComponent
} from './cellRender/popover-header-cell-render/popover-header-cell-render.component';
import {
  XEAPopoverTableCellRendererComponent
} from './cellRender/popover-table-cell-renderer/popover-table-cell-renderer.component';

import { HeaderCellComponent } from './cellRender/header-cell/header-cell.component';

export const GRID_FILTER_COMPONENTS = [CustomFilterComponent];

export const GRID_RENDER_COMPONENTS = [
  FlexButtonGroupRendererComponent,
  EntitySummaryRendererComponent,
];

export const customGridComponents = [
  XVICustomSelectRendererComponent,
  XEAPopoverComponent,
  XEAPopoverHeaderCellRendererComponent,
  HeaderCellComponent,
  XEAPopoverTableCellRendererComponent,
  CheckboxCellComponent,
  CheckboxHeaderCellComponent,
];

export const xviCustomGridRenderers = {
  customSelectRenderer: XVICustomSelectRendererComponent,
  popoverRenderer: XEAPopoverTableCellRendererComponent,
  nameIdRenderer: EntitySummaryRendererComponent,
};

export const xviCustomGridFilters = {
  customFilter: CustomFilterComponent,
};

export const xviCustomGridComponents = {
  // renderers
  ...xviCustomGridRenderers,
  // filters
  ...xviCustomGridFilters,
};
